import { Button, styled } from "tamagui";
import { backgroundPrimaryHex, strokePrimaryHex } from "../themes/legacy/colors-granted";
import { AppleLogo, GoogleLogo } from "./custom-icons";
import { Separator } from "./Separator";
import { XStack, YStack } from "./Stacks";
import { Paragraph } from "./Typography";

// Tamagui button has weird theming issues, so we style it with hex values.
const OAuthButton = styled(Button, {
  name: "OAuthButton",
  unstyled: true,
  cursor: "pointer",
  flex: 1,
  width: "100%",
  borderRadius: "$br2",
  height: "$5",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "center",
  gap: "$2",
  backgroundColor: backgroundPrimaryHex,
  borderWidth: 1,
  borderColor: strokePrimaryHex,
  transition: "bouncyTight",
  hoverStyle: {
    backgroundColor: "rgba(255,255,255,0.65)",
    borderColor: "$cream10",
    shadowColor: backgroundPrimaryHex,
    shadowOpacity: 0.8,
    shadowRadius: 10
  },
  pressStyle: {
    backgroundColor: "rgba(255,255,255,0.45)",
    borderColor: "$cream10",
    shadowColor: backgroundPrimaryHex,
    shadowOpacity: 0.8,
    shadowRadius: 14,
    scale: 0.98
  }
});
const ButtonText = styled(Paragraph, {
  name: "ButtonText",
  mt: 1,
  textAlign: "left",
  color: "$textDefault"
});
export type OAuthProviderType = "APPLE" | "GOOGLE";
export type OAuthButtonsIntent = "continue" | "signUp";
export const OAuthButtons = ({
  onPress,
  intent = "continue"
}: {
  onPress: (provider: OAuthProviderType) => void;
  intent?: OAuthButtonsIntent;
}) => {
  const verb = intent === "signUp" ? "Sign up" : "Continue";
  return <YStack gap="$2" data-sentry-element="YStack" data-sentry-component="OAuthButtons" data-sentry-source-file="OAuthButtons.tsx">
      <OAuthButton icon={<GoogleLogo />} onPress={() => onPress("GOOGLE")} data-sentry-element="OAuthButton" data-sentry-source-file="OAuthButtons.tsx">
        <ButtonText data-sentry-element="ButtonText" data-sentry-source-file="OAuthButtons.tsx">{`${verb} with Google`}</ButtonText>
      </OAuthButton>
      <OAuthButton icon={<AppleLogo transform="translate(0, -1.5)" />} onPress={() => onPress("APPLE")} data-sentry-element="OAuthButton" data-sentry-source-file="OAuthButtons.tsx">
        <ButtonText data-sentry-element="ButtonText" data-sentry-source-file="OAuthButtons.tsx">{`${verb} with Apple`}</ButtonText>
      </OAuthButton>
    </YStack>;
};
export const OAuthDivider = () => <XStack alignItems="center" gap="$2" height="$2" pb="$1" data-sentry-element="XStack" data-sentry-component="OAuthDivider" data-sentry-source-file="OAuthButtons.tsx">
    <Separator borderBottomColor="$strokeSecondary" borderBottomWidth={1} mt={4} data-sentry-element="Separator" data-sentry-source-file="OAuthButtons.tsx" />
    <Paragraph theme="alt1" data-sentry-element="Paragraph" data-sentry-source-file="OAuthButtons.tsx">or</Paragraph>
    <Separator borderBottomColor="$strokeSecondary" borderBottomWidth={1} mt={4} data-sentry-element="Separator" data-sentry-source-file="OAuthButtons.tsx" />
  </XStack>;